// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1q8Yp","insightsList":"newBusinessInsightsMenu_insightsList__3ooTS","active":"newBusinessInsightsMenu_active__37Pzh"};